module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/diseases/head-9a43b76b68e78175d22bf982f9e96bf8.png";